<template>
  <div class="d-flex m-3 gap-2">

    <!-- Main Content -->
    <div class="w-75 d-flex flex-column gap-3">
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-1">Member Stack</h4>
        <h5 class="text-gray-600 mb-2">Use member stack component to display list of members in an array of stack wether horizontal or vertical.</h5>

        <h5 class="mt-4 mb-2">How to Import</h5>
        <p class="text-gray-600">To import the MemberStack component, install its package from bit.dev</p>
        <code class="bg-gray-100 p-3 mt-2 mb-3">yarn add @bit/dtt.uic.dt-member-stack</code>
        <p class="text-gray-600">To use the MemberStack component in your Vue component.</p>
        <code class="bg-gray-100 p-3 mt-2">import DtMemberStack from '@bit/dtt.uic.dt-member-stack'</code>
      </div>

      <MemberStackSample />
      <MemberStackSizes />
      <MemberStackAlignment />

      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-2">Props</h4>
        <b-table striped bordered :items="propsItems" :fields="propsFields"></b-table>
      </div>
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-2">Events</h4>
        <b-table striped bordered :items="eventItems" :fields="eventFields"></b-table>
      </div>
    </div>
  </div>
</template>

<script>
import MemberStackSample from '@/components/local/MemberStack/MemberStackSample'
import MemberStackSizes from '@/components/local/MemberStack/MemberStackSizes'
import MemberStackAlignment from '@/components/local/MemberStack/MemberStackAlignment'

export default {
  components: { MemberStackSample, MemberStackSizes, MemberStackAlignment },
  data () {
    return {
      propsFields: [
        { key: 'prop', tdClass: 'code-text' },
        { key: 'type', tdClass: 'code-text' },
        { key: 'default', tdClass: 'code-text' },
        { key: 'description' }
      ],
      propsItems: [
        { prop: 'id', type: 'String', default: 'null', description: 'Used to set the id attribute on the rendered content' },
        { prop: 'size', type: 'String', default: 'md', description: `Set the size of the component's appearance. 'sm', 'md' (default), or 'lg'` },
        { prop: 'canAdd', type: 'Boolean', default: 'false', description: 'Wether to show and add user icon at the end of the stack' },
        { prop: 'members', type: 'Array', default: '', description: 'The value for the member stack' },
        { prop: 'vertical', type: 'String', default: 'false', description: 'Set the orientation of stack to vertical' },
        { prop: 'showCount', type: 'String or Number', default: '5', description: 'Set the visible amount of members' },
      ],
      eventFields: [
        { key: 'event', tdClass: 'code-text' },
        { key: 'arguments' },
        { key: 'description' }
      ],
      eventItems: [
        { event: 'add-more', arguments: 'event - Click Event', description: 'Emitted when the add user icon is clicked' },
        { event: 'member-clicked', arguments: 'value - Returns the object of the clicked member', description: 'Emitted when a member icon is clicked' },
      ]
    }
  }
}
</script>
